import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'components/core/Card';
import { Image } from 'components/core/Image';
import { Paragraph, Text } from 'components/core/Typography';
import { ClickToShowNumberButton } from 'components/contact/ClickToShowNumberButton';
import { Row, Column } from 'components/core/Page';

import emptyFacility from 'assets/images/search/empty-facility-agent.webp';

import './EmptyFacilityList.scss';

export function EmptyFacilityList({ getTollfreePhoneNumber }) {
	return (
		<Card className="empty-facility-list">
			<Row>
				<Column large={4}>
					<div className="empty-list-image">
						<div className="image-cropper">
							<Image
								src={emptyFacility}
								alt=""
								ariaHidden={true}
								role="presentation"
								className="image-cropper-img"
							/>
						</div>
						<Paragraph strong size="medium">
							Give us a call
						</Paragraph>
						<ClickToShowNumberButton
							outline
							fetchPhoneNumber={getTollfreePhoneNumber}
							showAsLink
							size="small"
						/>
					</div>
				</Column>
				<Column large={8}>
					<Paragraph size="medium" strong>
						We can't find any storage facilities that match your search.
					</Paragraph>
					<div className="empty-list-description">
						<Paragraph>
							You can try changing your search, or one of our storage experts
							would be happy to assist you! They'll help you compare units
							based on price, location, size, and more to help you save time
							and money.
						</Paragraph>
						<ul className="empty-list-description-list">
							<li>
								<Text>
									Largest selection of storage options
								</Text>
							</li>
							<li>
								<Text>
									Access to exclusive deals
								</Text>
							</li>
							<li>
								<Text>
									Free support & easy reschedules
								</Text>
							</li>
							<li>
								<Text>
									Available 7 days a week
								</Text>
							</li>
						</ul>
					</div>
				</Column>
			</Row>
		</Card>
	);
}


EmptyFacilityList.propTypes = {
	getTollfreePhoneNumber: PropTypes.func.isRequired
};
export default EmptyFacilityList;
